module.exports = __webpack_public_path__ + "static/media/  (95).2322c312.jpg";